import { ScheduleEntry } from "../../src/models/types/voyage-schedules-model.types";
import { VoyagePlan } from "../../src/models/vessel-planning-model";
import { getDraftDatabase } from "../drafts_db_manager";

export class IndexedDraftsDBService {

 static plans = {
  async getAll(): Promise<VoyagePlan[]> {
    return await getDraftDatabase().plan.getAllPlans();
  },
  async get(id: number) {
    return await getDraftDatabase().plan.getPlan(id);
  },
  async add(plan: VoyagePlan) {
    return await getDraftDatabase().plan.addPlan(plan);
  },
  async update(id: number, plan: VoyagePlan) {
    return await getDraftDatabase().plan.updatePlan(id, plan);
  },
  async delete(id: number) {
    return await getDraftDatabase().plan.deletePlan(id);
  }
};

static schedules = {
  async getAll() {
    return await getDraftDatabase().schedule.getAllSchedules();
  },
  async get(id: string) {
    return await getDraftDatabase().schedule.getSchedule(id);
  },
  async add(schedule: ScheduleEntry) {
    return await getDraftDatabase().schedule.addSchedule(schedule);
  },
  async update(id: string, schedule: ScheduleEntry) {
    return await getDraftDatabase().schedule.updateSchedule(id, schedule);
  },
  async delete(id: string) {
    return await getDraftDatabase().schedule.deleteSchedule(id);
  }
};
}